import HomeContainer from '../../../Container/Dor/Home';

const Home = () => {
	return (
		<HomeContainer />
	)
}

export default Home;
